import { useLayoutEffect, useRef, useState } from 'react'

export const useAnimatedWidth = (scope: string, enabled = true) => {
  const contentRef = useRef<HTMLSpanElement>(null)
  const [measured, setMeasured] = useState<{ scope: string; width: number }>()

  useLayoutEffect(() => {
    const node = contentRef.current
    if (!enabled || !node) return
    const measure = () => {
      const width = node.offsetWidth
      if (!width) return
      setMeasured((previous) => (previous?.scope === scope && previous.width === width ? previous : { scope, width }))
    }
    measure()
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : undefined
    observer?.observe(node)
    return () => observer?.disconnect()
  })

  return { contentRef, width: enabled && measured?.scope === scope ? measured.width : undefined }
}
